class HttpErrorManager {
    constructor(lang = 'en', keys = {}) {
        this.lang = lang;
        this.errorMessage = {
            en: {
                error_0: 'No response from server.',
                error_401: 'The authentication information provided are incorrect.',
                error_403: 'Insufficient permissions, please contact an administrator.',
                error_412: 'You are registered. You will receive an email for validation.',
                EMAIL_NOT_AUTHORIZED_TO_REGISTER: 'This email is not authorized for register.',
                EXPIRED_PASSWORD: 'Your password has expired.',
                PASSWORD_INSECURE: 'Your password must contain at least 8 characters, 1 digit, 1 minuscule, 1 uppercase and 1 special character.',
                EMAIL_NOT_VALIDATED: 'Your account has not been activated, an activation email has been sent to your mailbox.',
                WRONG_AUTH_CREDENTIALS: 'Wrong login credentials.',
                WRONG_VERIFICATION_CODE: 'Wrong confirmation code.',
                CANNOT_USE_SAME_PASSWORD:'Please choose a different password than the previous one.',
                USER_BLOCKED:'Your account has been blocked. Please contact an administrator.',
                INSUFFICIENT_PERMISSIONS: 'You do not have sufficient rights to connect to this interface.',
                WRONG_EMAIL_ADDRESS: 'Wrong email address',
                INVALID_TOKEN: 'The token used is invalid',
                TOKEN_HAS_EXPIRED: 'The token has expired',
                PROTECTED_RELATION: 'Protected related model',
                MFA_TEMP_TOKEN_EXPIRED: 'MFA temporary token expired',
                MFA_TEMP_TOKEN_INVALID: 'MFA temporary token is invalid',
            },
            fr: {
                error_0: 'Aucune réponse du serveur.',
                error_401: 'Les informations d\'authentification fournies sont incorrectes.',
                error_403: 'Vous n\'avez pas les permissions nécessaires, veuillez contacter un administrateur.',
                error_412: 'Vous vous êtes bien inscrit. Vous allez recevoir un email pour confirmer votre compte.',
                EMAIL_NOT_AUTHORIZED_TO_REGISTER: 'Cet email n’est pas autorisé pour les inscriptions.',
                EXPIRED_PASSWORD: 'Votre mot de passe a expiré.',
                PASSWORD_INSECURE: 'Votre mot de passe doit comporter au minimum 8 caractères, 1 chiffre, 1 minuscule, 1 majuscule et 1 caractère spécial.',
                EMAIL_NOT_VALIDATED: 'Votre compte n\'a pas été activé, un email d\'activation a été envoyé sur votre boîte mail.',
                WRONG_AUTH_CREDENTIALS: 'Vos identifiants de connexion sont incorrects.',
                WRONG_VERIFICATION_CODE: 'Code de confirmation incorrect.',
                CANNOT_USE_SAME_PASSWORD:'Veuillez choisir un mot de passe différent que le précédent.',
                USER_BLOCKED:'Votre compte a été bloqué. Veuillez contacter un administrateur.',
                INSUFFICIENT_PERMISSIONS: 'Votre compte n\'a pas les droits nécessaires pour se connecter à cette interface.',
                WRONG_EMAIL_ADDRESS: 'l’adresse email est invalide',
                INVALID_TOKEN: 'le jeton est invalide',
                TOKEN_HAS_EXPIRED: 'le jeton a expiré',
                PROTECTED_RELATION: 'Un model lié est protégé',
                MFA_TEMP_TOKEN_EXPIRED: 'Le jeton de MFA temporaire a expiré',
                MFA_TEMP_TOKEN_INVALID: 'Le jeton de MFA temporaire est invalide',
            }
        };

        for (let key in keys.en) {
            this.errorMessage.en[key] = keys.en[key];
            this.errorMessage.fr[key] = keys.fr[key];
        }
    }

    getFirstCode(errors){
        return this.getCodes(errors)[0];
    }

    getCodes(errors){
        if(errors instanceof Array){
            return errors;
        }else{
            return [errors];
        }
    }

    getMessage(status, keys = null, callback = null) {
        if (callback === null) {
            callback = msg => {
                return msg;
            };
        }
        if (keys === null) {
            keys = [`error_${status}`];
        }

        let msg = this.getCodes(keys).map((error) => {
            return this.errorMessage[this.lang][error];
        }).join(' ');

        return callback(msg);
    }
}

export default HttpErrorManager;



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/components/partials/http-error-manager.js
// module id = W+RP
// module chunks = 0